import {
  HierarchyNodeMetadata,
  findLocationEntry,
  findLocationEntryWithParents
} from '@domain/shared'

import {Comment} from '../types'

/** Comments posted on the given location or any of its descendants */
export const filterCommentsByLocation = (
  comments: Comment[],
  hierarchy: HierarchyNodeMetadata,
  locationId: string
): Comment[] => {
  return comments.filter((comment) => {
    const commentLocation = findLocationEntry(hierarchy, comment.locationId)
    return commentLocation?.path.includes(locationId)
  })
}

/** "Country > Plant" style label of a comment location, relative to the scope location */
export const getLocationEntryWithParentsLabel = (
  scopeLocationId: string,
  commentLocationId: string,
  hierarchy: HierarchyNodeMetadata
) =>
  findLocationEntryWithParents(hierarchy, commentLocationId)
    ?.filter(({path, id}) => path.includes(scopeLocationId) && id !== scopeLocationId)
    .map(({name}) => name)
    .join(' > ')
